import { Loan, OnboardingDetailsRole, OnboardingDetailsType } from '@nemuru-eng/js-api-client';

export const resolveEditFinancingDateOfBirth = (loan: Loan | null | undefined): Date | undefined => {
  const borrowerOnboardingDetails = loan?.onboardingDetails.find(
    (details) => details.role === OnboardingDetailsRole.BORROWER,
  );

  if (!borrowerOnboardingDetails) {
    return undefined;
  }

  if (borrowerOnboardingDetails.type === OnboardingDetailsType.BORROWER) {
    return borrowerOnboardingDetails.userDetails?.documentId?.birthDate ?? undefined;
  }

  if (borrowerOnboardingDetails.type === OnboardingDetailsType.ONLINE) {
    return borrowerOnboardingDetails.birthDate ?? undefined;
  }

  return undefined;
};
